import styles from "./authorDetailPanel.module.scss";
import StoryblokImageBasic from "../../../components/storyblokImageBasic/storyblokImageBasic";
import RichTextWithBlokRenderer from "../../../components/richTextRenderer/richTextRenderer";
import { useStoryblokGlobalSettings } from "../../../hooks/useStoryblokGlobalSettings";
import {
  FacebookSVG,
  YoutubeSVG,
  InstagramSVG,
  TwitterSVG,
  WebsiteSVG,
  PodcastSVG,
  TikTokSVG,
  BlogSVG,
  AuthorBackgroundLinesLeftSVG,
  AuthorBackgroundLinesRightSVG,
} from "../../../svg";
import StoryblokLink from "../../../components/link/StoryblokLink";

const getSocialMediaIcon = (network) => {
  switch (network) {
    case "twitter":
      return <TwitterSVG />;
    case "instagram":
      return <InstagramSVG />;
    case "facebook":
      return <FacebookSVG />;
    case "youtube":
      return <YoutubeSVG />;
    case "podcast":
      return <PodcastSVG />;
    case "website":
      return <WebsiteSVG withClass={styles.strokeSVG} />;
    case "tiktok":
      return <TikTokSVG />;
    case "blog":
      return <BlogSVG withClass={styles.strokeSVG} />;
    default:
      return <WebsiteSVG withClass={styles.strokeSVG} />;
  }
};

const sortSocialMedia = (socialMedia) => {
  if(!socialMedia) { return socialMedia }
  const priority = [
    'facebook',
    'twitter',
    'youtube',
    'instagram'
  ];
  return socialMedia.sort((a, b) => {
    const aIndex = priority.indexOf(a.network);
    const bIndex = priority.indexOf(b.network);
    return (
      (aIndex === -1 ? priority.length : aIndex) -
      (bIndex === -1 ? priority.length : bIndex)
    )
  })
}

function AuthorDetailPanel({ socialMedia, name, byline, bio, image, withClass }) {
  const globalSettings = useStoryblokGlobalSettings();

  if(!socialMedia) {
    return null;
  }

  const defaultAuthorImage = globalSettings
    ? globalSettings.default_author_image
    : null;
  
  const orderedSocialMedia = sortSocialMedia(socialMedia);

  const SocialMediaIcons = ({ mobile }) => {
    return (
      <div
        className={
          `${styles.socialIcons}` +
          (mobile ? ` ${styles.mobileIcons}` : ` ${styles.desktopIcons}`)
        }
      >
        {orderedSocialMedia.map((item) => (
          <div key={item._uid} className={styles.socialIconWrapper}>
            <StoryblokLink linkObject={item.url} className={styles.socialIcon}>
              {getSocialMediaIcon(item.network)}
            </StoryblokLink>
          </div>
        ))}
      </div>
    );
  };

  const imageToUse = image && image.filename ? image : defaultAuthorImage;

  return (
    <div className={`${styles.root} ${withClass}`}>
      <div className={styles.leftImage}>
        <AuthorBackgroundLinesLeftSVG />
      </div>

      <div className={styles.rightImage}>
        <AuthorBackgroundLinesRightSVG />
      </div>
      <div className={styles.content}>
        <div className={styles.imageAndSocials}>
          <div className={styles.imageContainer}>
            {imageToUse && imageToUse.filename ? (
              <StoryblokImageBasic
                image={imageToUse}
                width={100}
                height={100}
              />
            ) : null}
          </div>
          <SocialMediaIcons mobile={false} />
        </div>

        <div className={styles.authorDetails}>
          <div className={styles.nameAndTitle}>
            <h2 className={styles.authorName}>{name}</h2>
            <p className={styles.authorTitle}>{byline}</p>
          </div>
          <SocialMediaIcons mobile={true} />
          <span className={styles.description}>
            <RichTextWithBlokRenderer document={bio} />
          </span>
        </div>
      </div>
    </div>
  );
}

export default AuthorDetailPanel;
